export default __webpack_public_path__ + "static/v-a90d14cc1a96960472f3d47bb2b900c0.png";